import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import parseISO from 'date-fns/parseISO';
import _isEmpty from 'lodash/isEmpty';

import { makePath } from 'helpers/link-generation';
import { bem } from 'helpers/class-name';
import Message from 'components/Message';
import Confirm from 'components/Confirm';
import messages from '../../ScheduleForm.messages';

import './ScheduleConflictsModal.scss';

const { block, element } = bem('schedule-conflicts-modal');

const ScheduleConflictsModal = ({ venueId, conflictedSchedules }) => (
  <Confirm
    className={block()}
    cancelNode={<Message message={messages.modals.close} />}
    title={<Message message={messages.modals.scheduleConflicts.title} />}
    subtitle={<Message message={messages.modals.scheduleConflicts.description} />}
    size="extended">
    <div className={element('date-list')}>
      {!_isEmpty(conflictedSchedules) &&
        Object.keys(conflictedSchedules).map(key =>
          conflictedSchedules[key].map(date => (
            <li key={date}>
              <Link
                to={makePath.schedulesEdit({
                  venueId,
                  id: key,
                  startDate: parseISO(date),
                })}>
                <Message format="short-w-time" value={parseISO(date)} />
              </Link>
            </li>
          ))
        )}
    </div>
  </Confirm>
);

ScheduleConflictsModal.propTypes = {
  venueId: PropTypes.number,
  conflictedSchedules: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
};

export default ScheduleConflictsModal;
